<template>
  <div class="m-15">
    <picture-input
      ref="pictureInput"
      width="300"
      height="300"
      margin="16"
      accept="image/jpeg, image/png"
      :removable="true"
      button-class="changeBtn"
      removeButtonClass="removeBtn"
      size="10"
      :custom-strings="{
                      upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
                      drag: 'Arraste uma imagem <br> (ou clique aqui)',
                      change: 'Mudar foto'
                    }"
      @change="onChange"
    ></picture-input>
  </div>
</template>

<script>
import PictureInput from "vue-picture-input";

export default {
  name: "inserirpromocaoimagem",
  components: {
    PictureInput
  },
  methods: {
    onChange(image) {
      if (image) {
        localStorage.setItem("image", image);
      }
    }
  },
  beforeMount() {
    this.$emit("can-continue", { value: true });
  }
};
</script>
